import Noty from 'noty'

var socket = {
  state: {
    totalWorkers : 0,
    totalPaid    : 0,
    totalMiners  : 0,
    totalChanged : false,
    version: ''
  },
  mutations: {
    SET_TOTAL_WORKERS (state, totalWorkers) {
      state.totalWorkers = totalWorkers
    },
    SET_TOTAL_PAID (state, totalPaid) {
      state.totalPaid = totalPaid
    },
    SET_TOTAL_MINERS (state, totalMiners) {
      state.totalMiners = totalMiners
    },
    SET_TOTAL_CHANGED (state) {
      state.totalChanged = true
      setTimeout(function () {
        state.totalChanged = false
      }, 310)
    },
    SET_CURRENT_VERSION(state, version) {
      state.version = version
    }
  },
  actions: {
    socket_statsWorkers ({ commit }, params) {
      // Capture server emit stats_workers
      commit('SET_TOTAL_WORKERS', params)
      commit('SET_TOTAL_CHANGED')
    },
    socket_statsPaid ({ commit }, params) {
      // Capture server emit stats_paid
      if (params.indexOf(',') > -1) params = params.replaceAll(',', '')
      commit('SET_TOTAL_PAID', params)
      commit('SET_TOTAL_CHANGED')
    },
    socket_statsMiners ({ commit }, params) {
      // Capture server emit stats_miners
      commit('SET_TOTAL_MINERS', params)
      commit('SET_TOTAL_CHANGED')
    },
    socket_version({ commit, state }, params) {
      if (params && params.p === 'web') {
        // Compare against local version, to show a message
        if (state.version !== params.v || params.f) {
          new Noty({
            text: 'There is a newer version of the website, please reload to get the latest update!',
            theme: 'relax',
            type: 'warning',
            layout: 'bottomCenter',
            timeout: false,
            progressBar: false,
            killer: true,
            template: '<div class="noty_message reload"><span class="noty_text"></span><div class="noty_close"></div></div>'
          }).show()
        }
        // Save website new version
        commit('SET_CURRENT_VERSION', params.v)
      }
    },
    socket_connect () {
      console.log('Stats socket connected!')
    },
    manuallySetGloballyTotals ({ commit }, params) {
      commit('SET_TOTAL_WORKERS', params.totalWorkers)
      commit('SET_TOTAL_PAID', params.totalPaid)
      commit('SET_TOTAL_MINERS', params.totalMiners)
      commit('SET_TOTAL_CHANGED')
    },
    joinSocketRoom ({ commit }, params) {
    }
  },
  getters: {
    totalWorkers : (state) => state.totalWorkers,
    totalPaid    : (state) => state.totalPaid,
    totalMiners : (state) => state.totalMiners,
    totalChanged : (state) => state.totalChanged
  }
}

export default socket



// WEBPACK FOOTER //
// ./src/store/socket.js